import { Check } from "lucide-react";

interface StepperProps {
  currentStep: number;
  steps: string[];
}

export default function Stepper({ currentStep, steps }: StepperProps) {
  return (
    <div className="rounded-[10px] border border-line bg-card p-6 shadow-card">
      {/* Desktop stepper */}
      <div className="hidden items-start md:flex">
        {steps.map((label, i) => {
          const step = i + 1;
          const completed = step < currentStep;
          const active = step === currentStep;
          return (
            <div key={label} className="flex flex-1 items-start">
              {i > 0 && (
                <div className="mx-4 mt-[18px] h-0.5 flex-1 rounded bg-slate-200">
                  <div
                    className="h-0.5 rounded bg-primary-500"
                    style={{ width: completed ? "100%" : "0%" }}
                  />
                </div>
              )}
              <div className="flex shrink-0 flex-col items-center gap-2">
                <div
                  className={`flex h-9 w-9 items-center justify-center rounded-full text-sm font-semibold transition-colors ${
                    completed || active
                      ? "bg-primary-500 text-white"
                      : "border border-slate-300 bg-white text-ink-muted"
                  }`}
                >
                  {completed ? <Check className="h-4 w-4" /> : step}
                </div>
                <span
                  className={`text-[13px] font-medium ${
                    active
                      ? "text-primary-500"
                      : completed
                        ? "text-ink"
                        : "text-ink-muted"
                  }`}
                >
                  {label}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      {/* Mobile progress */}
      <div className="md:hidden">
        <p className="text-sm font-medium text-ink">
          Step {currentStep} of {steps.length} — {steps[currentStep - 1]}
        </p>
        <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
          <div
            className="h-1.5 rounded-full bg-primary-500 transition-all duration-300"
            style={{ width: `${(currentStep / steps.length) * 100}%` }}
          />
        </div>
      </div>
    </div>
  );
}